const u=(()=>{let t=Number.MIN_SAFE_INTEGER;const n=new WeakMap;return e=>{if(!e)return`${t++}`;const r=n.get(e);if(!r){const s=`${t++}`;return n.set(e,s),s}return r}})();export{u as getUniqueId};
//# sourceMappingURL=getUniqueId.js.map
